import { connect, useDispatch } from "react-redux";
import logo from "../../images/logo.png";
import CustomInput from "../DesignSystem/CustomInput/CustomInput";
import Button from "../DesignSystem/Button/Button";
import { useRef, useState } from "react";
import { faEnvelope, faLock } from "@fortawesome/free-solid-svg-icons";
import { useIntl } from "react-intl";
import { showToast } from "../../store/thunks/toasts";
import { STATE_DANGER, STATE_DEFAULT, TOAST_STATE_DANGER } from "../../utils/constants";
import { signin } from "../../store/thunks/signin";
import { push } from "connected-react-router";
import { ROUTE_DASHBOARD } from "../app/routes";
import { preload } from "../../store/thunks/preload";

let formState = {
	username: false,
	password: false,
};

export default connect((state) => ({}), { signin })(() => {
	const dispatch = useDispatch();
	const { formatMessage } = useIntl();

	const [username, setUsername] = useState("");
	const [usernameInputState, setUsernameInputState] = useState("");
	const [usernameError, setUsernameError] = useState("");

	const [password, setPassword] = useState("");
	const [passwordInputState, setPasswordInputState] = useState("");
	const [passwordError, setPasswordError] = useState("");

	const [buttonDisabled, setButtonDisabled] = useState(true);

	const usernameInput = useRef();
	const passwordInput = useRef();

	const validateField = (inputValue, onError, errorMessage, stateKey) => {
		let isError = false;

		if (!inputValue.length) {
			onError(formatMessage({ id: errorMessage }));
			isError = true;
		}

		if (isError) {
			setButtonDisabled(true);
			formState[stateKey] = false;
		} else {
			setButtonDisabled(false);
			formState[stateKey] = true;
		}

		return isError;
	};

	const handleUsernameChange = () => {
		setUsernameError("");
		const state = validateField(usernameInput.current.value, setUsernameError, "sigin.username.error", "username");
		setUsernameInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setUsername(usernameInput.current.value);

		return state;
	};

	const handlePasswordChange = () => {
		setPassword("");
		const state = validateField(passwordInput.current.value, setPassword, "sigin.password.error", "password");
		setPasswordInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setPassword(passwordInput.current.value);

		return state;
	};

	const onClickSignin = async () => {
		if (Object.values(formState).filter((value) => !value).length !== 0) {
			dispatch(showToast({ message: "sigin.generic.error", type: TOAST_STATE_DANGER }));
			return;
		}

		const payload = {
			username,
			password,
		};

		const signinResponse = await dispatch(signin(payload));
		if (signinResponse) {
			await dispatch(preload());
			dispatch(
				push({
					pathname: ROUTE_DASHBOARD,
				})
			);
		}
	};

	return (
		<div className="flex direction-col justify-content-center align-items-center pt-48">
			<div>
				<img src={logo} alt="logo" />
				<CustomInput
					id="username"
					label="signin.username"
					icon={faEnvelope}
					placeholder="signin.username.placeholder"
					ref={usernameInput}
					className="mt-16"
					state={usernameInput}
					onChange={handleUsernameChange}
				/>
				<CustomInput
					id="password"
					label="signin.password"
					type="password"
					icon={faLock}
					placeholder="signin.password.placeholder"
					ref={passwordInput}
					className="mt-16"
					state={passwordInputState}
					onChange={handlePasswordChange}
				/>
				<Button label="signin.signin" className="button-primary button-block mt-24" onClick={onClickSignin} />
			</div>
		</div>
	);
});
